<template>
    <div>
        <div class="spacer-56"></div>

        <div class="fs-2 fw-700 text-center">
            {{ $trans('storefront::flexible_packaging.standard_size') }}
        </div>

        <div class="fs-3 text-center">
            {{ $trans('storefront::flexible_packaging.standard_size_description') }}
        </div>

        <div class="spacer-56"></div>

        <div class="d-flex justify-content-center">
            <div class="d-flex flex-wrap justify-content-center gap-24" style="max-width: 1021px">
                <template v-for="(item, index) in items">
                    <flexible-packaging-option-small
                        :active="!customSize.enabled && store.data.pouch_size === item.title"
                        :icon="$getImg(item.imgSrc)"
                        :title="item.title"
                        @click.native="handleClick({value: item.title})"
                    ></flexible-packaging-option-small>
                </template>

<!--                <flexible-packaging-option-small-->
<!--                    :active="customSize.enabled"-->
<!--                    @click.native="customSize.enabled = true"-->
<!--                >-->
<!--                    <label for="width" class="fs-6 fw-500">{{$trans('storefront::flexible_packaging.width')}}"</label>-->
<!--                    <input type="number" class="form-control form-control-primary" v-model="customSize.width">-->
<!--                    <label for="height" class="fs-6 fw-500">{{$trans('storefront::flexible_packaging.height')}}"</label>-->
<!--                    <input type="number" class="form-control form-control-primary" v-model="customSize.height">-->

<!--                    <div class="fw-500 mt-2 text-muted">-->
<!--                        Lorem ipsum-->
<!--                    </div>-->
<!--                </flexible-packaging-option-small>-->
            </div>
        </div>
    </div>
</template>

<script>
import {useFlexiblePackagingStore} from "../../../js/store";
import FlexiblePackagingOptionSmall from "../../inc/FlexiblePackagingOptionSmall";

export default {
    components: {FlexiblePackagingOptionSmall},
    setup() {
        const store = useFlexiblePackagingStore();
        return {
            store: store,
        }
    },
    data() {
        return {
            customSize: {
                enabled: false,
                width: 3,
                height: 3,
            },
            items: [
                {
                    imgSrc: 'flexible-packaging/pouch-sizes/side-plow/2.5x7@2x.png',
                    title: '2.5" x 7"',
                },
                {
                    imgSrc: 'flexible-packaging/pouch-sizes/side-plow/3x3@2x.png',
                    title: '3" x 3"',
                },
                {
                    imgSrc: 'flexible-packaging/pouch-sizes/side-plow/3x6@2x.png',
                    title: '3" x 6"',
                },
                {
                    imgSrc: 'flexible-packaging/pouch-sizes/side-plow/3.5x4.25@2x.png',
                    title: '3.5" x 4.25"',
                },
                {
                    imgSrc: 'flexible-packaging/pouch-sizes/side-plow/4x4.5@2x.png',
                    title: '4" x 4.5"',
                },
                {
                    imgSrc: 'flexible-packaging/pouch-sizes/side-plow/5x7@2x.png',
                    title: '5" x 7"',
                },
                {
                    imgSrc: 'flexible-packaging/pouch-sizes/side-plow/6x9@2x.png',
                    title: '6" x 9"',
                },
                {
                    imgSrc: 'flexible-packaging/pouch-sizes/side-plow/9.5x13@2x.png',
                    title: '9.5" x 13"',
                },
            ],
        };
    },
    methods: {
        handleClick({value}) {
            this.customSize.enabled = false;
            this.store.data.pouch_size = value;
        },
        setCustomWidth() {
            if (!this.customSize.enabled) return;

            function clamp(value, min, max) {
                return Math.max(min, Math.min(value, max));
            }

            this.customSize.width = clamp(this.customSize.width, 1, 13);
            this.customSize.height = clamp(this.customSize.height, 1, 13);
            this.store.data.pouch_size = `Custom ${this.customSize.width}" x ${this.customSize.height}`;
        }
    },
    watch: {
        'customSize.enabled': function() {
            this.setCustomWidth();
        },
        'customSize.width': function() {
            this.setCustomWidth();
        },
        'customSize.height': function() {
            this.setCustomWidth();
        },
    }
}
</script>
